'use client'
import { UseQueryResult, useQuery } from '@tanstack/react-query'
import services from '../services'
import { apiResponseHandler, queryKeys } from '@/shared/api/react-query'
import { GetHypothesesParams } from '@/shared/api/end-points/hypothesis'
import { Hypothesis, hypothesisMappers } from '../../lib'

const useHook = (params: GetHypothesesParams) => {
  const queryKey = [queryKeys((a, m, p) => a.hypothesis.getHypotheses(params) + m.get)]

  const query = useQuery({
    queryKey,
    queryFn: async () => apiResponseHandler(await services.get(params)),
    refetchOnWindowFocus: false,
  })

  const queryResult = {
    ...query,
    queryKey,
    data: hypothesisMappers.mapHypotheses(query?.data || []),
  }

  return queryResult as unknown as UseQueryResult<Hypothesis[]>
}
export default useHook
